/**
 * Borda fração ↔ percentual da tela de Simulações (S6 / contrato §3).
 *
 * A API fala em FRAÇÃO (0,05 = 5%); a pessoa digita e lê PERCENTUAL com vírgula ("2,5").
 * Estas funções são a ÚNICA conversão permitida na UI: não calculam comissão, faixa nem
 * líquido — só mudam a unidade de um número que o backend recebe ou devolveu.
 */

/** Fração (0,025) → percentual (2,5). Arredonda a 6 casas para apagar o ruído binário. */
export const fracaoParaPercentual = (fracao: number): number =>
  Math.round(fracao * 100 * 1e6) / 1e6

/** Percentual (2,5) → fração (0,025), com o mesmo arredondamento. */
export const percentualParaFracao = (percentual: number): number =>
  Math.round((percentual / 100) * 1e8) / 1e8

/**
 * Lê um percentual digitado em pt-BR ("2,5", "2.5", "12", " 0,5 % "). `null` quando não é
 * número — a tela destaca o campo e informa o formato (S4). Aceita "." como decimal
 * porque teclado numérico de celular costuma oferecer só o ponto.
 */
export const lerPercentualPtBr = (texto: string): number | null => {
  const limpo = texto.replace(/%/g, '').replace(/\s/g, '')
  if (limpo === '') return null
  // "1.234,5" → milhar com ponto e decimal com vírgula; "2.5" → decimal com ponto.
  const normalizado =
    limpo.includes(',') ? limpo.replace(/\./g, '').replace(',', '.') : limpo
  if (!/^-?\d+(\.\d+)?$/.test(normalizado)) return null
  const n = Number(normalizado)
  return Number.isFinite(n) ? n : null
}

/** Fração → "2,5%" (até 4 casas, vírgula). "—" quando nulo. */
export const pctDeFracao = (fracao: number | null | undefined): string =>
  fracao == null
    ? '—'
    : `${fracaoParaPercentual(fracao).toLocaleString('pt-BR', { maximumFractionDigits: 4 })}%`

/** Moeda pt-BR: `R$ 8.400.000,00`. "—" quando nulo. */
export const brl = (v: number | null | undefined): string =>
  v == null ? '—' : v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
